module.exports = __webpack_public_path__ + "img/packages/4.183a0b.png";